import { Bot, Server as ServerIcon, Globe, Radio, Ear, Shield, Layers } from 'lucide-react';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { IconBadge } from '@/components/shared/IconBadge';
import type { PluginManifest } from '@/lib/plugin-registry';

export function PluginTypeSection({ plugin }: { plugin: PluginManifest }) {
  return (
    <section data-testid="plugin-detail-section-type">
      <IconSectionHeader icon={Layers}>Type</IconSectionHeader>
      <div className="flex flex-wrap gap-2">
        {plugin.server && <IconBadge icon={ServerIcon}>Server</IconBadge>}
        {plugin.web && <IconBadge icon={Globe}>Web</IconBadge>}
        {plugin.server?.webhookProvider && <IconBadge icon={Radio}>Webhook Provider</IconBadge>}
        {(plugin.server?.webhookReceivers?.length ?? 0) > 0 && (
          <IconBadge icon={Ear}>Webhook Receiver</IconBadge>
        )}
        {plugin.server?.authProvider && <IconBadge icon={Shield}>Auth Provider</IconBadge>}
        {plugin.server?.agentProvider && <IconBadge icon={Bot}>Agent Provider</IconBadge>}
      </div>
    </section>
  );
}
